import { createReducer } from './utils'
import moment from 'moment';

import { arrayToObject } from '../helper'


export default createReducer({
    SHOP_BLOCKED: (state, action) => {
        return {
            ...state,
            blocked: action.blocked
        }
    },
    SHOP_DATA_LOADING: (state, action) => {
        return {
            ...state,
            loading: true
        }
    },
    SHOP_DATA_LOADED: (state, action) => {
        return {
            ...state,
            ...action.data,
            loading: false
        }
    },

    'SHOP_PREV_MONTH': (state, action) => {
        return {
            ...state,
            selectedMonthDate: 
                moment(state.selectedMonthDate).subtract(1, 'month')
        }
    },

    'SHOP_SET_MONTH': (state, action) => {
        return {
            ...state,
            selectedMonthDate: moment(action.date)
        }
    },

    'SHOP_NEXT_MONTH': (state, action) => {
        return {
            ...state,
            selectedMonthDate: 
                moment(state.selectedMonthDate).add(1, 'month')
        }
    },

    'SHOP_SELECT_OFFER': (state, action) => {
        const offer = action.offer ? state.offers[action.offer] : null;

        return {
            ...state,
            selectedOffer: action.offer,
            selectedSlots: offer && Math.min(offer.slots, state.selectedSlots) || 1,
            selectedDateAndSlotsConfirmed: false
        }
    },

    'SHOP_SELECT_SLOTS': (state, action) => {

        let slots = state.slots || [];

        while(slots.length < action.slots) {
            slots.push({})
        }

        slots = slots.splice(0, action.slots);

        console.log(action.slots, slots);

        return {
            ...state,
            selectedSlots: action.slots,
            slots: slots
        }
    },

    'SHOP_CHOOSE_CATEGORY': (state, action) => {
        return {
            ...state,
            selectedCategory: action.category,
            step: 'types'
        }
    },

    'SHOP_CHOOSE_TYPE': (state, action) => {
        return {
            ...state,
            selectedType: action.offerType,          
        }
    },

    'SHOP_CONFIRM_DATE_AND_SLOTS': (state, action) => {
        return {
            ...state,
            selectedDateAndSlotsConfirmed: action.confirmed,
        }
    },

    'SHOP_VOUCHER_TEXT_CHANGED': (state, action) => {
        return {
            ...state,
            voucherText: action.text,
        }
    },

    'SHOP_VOUCHER_AMOUNT_CHANGED': (state, action) => {
        return {
            ...state,
            voucherAmount: action.amount,
        }
    },

    'SHOP_VOUCHER_CONFIRMED': (state, action) => {
        return {
            ...state,
            voucherConfirmed: action.confirmed,
        }
    },

    'SHOP_BOOK': (state, action) => {
        return {
            ...state,
            selectedType: action.offerType,
            selectedTypeAsVoucher: action.voucher,
            step: 'calendar',
        }
    },

    'SHOP_INVOICE_INFO_UPDATED': (state, action) => {
        const invoiceInfo = {...state.invoiceInfo}
        invoiceInfo[action.name] = action.value;

        const requiredFields = [
            'salutation', 'firstName', 
            'lastName', 'email', 'street',
            'housenumber', 'city', 'email'
        ]

        let valid = true;
        for (var i = requiredFields.length - 1; i >= 0; i--) {
            const field = requiredFields[i];
            const value = invoiceInfo[field];
            if (!value || value.length < 2) {
                valid = false;
                break;
            }
        }

        return {
            ...state,
            invoiceInfo,
            invoiceInfoValid: valid
        }
    },

    'SHOP_CONFIRM_INVOICE_INFO': (state, action) => {
        return {
            ...state,
            invoiceInfoConfirmed: action.confirmed,
        }
    },

    'SHOP_PREV_STEP': (state, action) => {
        const nextStep = (step) => {
            switch(step) {
                case 'types':
                    return 'categories';
                case 'calendar':
                    return 'types';
                case 'voucher':
                    return 'calendar';
                case 'invoiceInfo':
                    if (state.selectedTypeAsVoucher)
                        return 'voucher'
                    return 'calendar';
                case 'order':
                    return 'slots'
            }

            return 'categories';
        }

        return {
            ...state,
            step: nextStep(state.step)
        };
    },

    'SHOP_NEXT_STEP': (state, action) => {
        const nextStep = (step) => {
            switch(step) {
                case 'calendar':
                    if (state.selectedTypeAsVoucher)
                        return 'voucher'
                    return 'invoiceInfo'
                case 'voucher':
                    return 'invoiceInfo'
                case 'invoiceInfo':
                    if (state.selectedTypeAsVoucher)
                        return 'order'
                    return 'slots'
                case 'slots':
                    return 'order'
            }

            return 'categories';
        }

        return {
            ...state,
            step: nextStep(state.step)
        };
    },
}, {
    selectedMonthDate: moment(),
    selectedDate: null,
    selectedSlots: 1,
    slots: [{}],
    trainingTypes: {
        
    }    
})




// WEBPACK FOOTER //
// ./src/reducers/shop.js